import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchOrders, fetchOrderSummary } from "../store/order-slice";
import DashboardCards from "../components/dashboard/DashboardCards";
import DashboardChat from "../components/dashboard/DashboardChat";
import { Role, Scope } from "../enums/enums";
import SubHeader from "../components/header/SubHeader";
import { getCardsData, getEmployeeCardsData, getRestaurantCardsData } from "../models/dashboardModel";
import { fetchAllContact } from "../store/contact-slice";
import { getEmployeeChartData } from "../models/dashboardModel";
import DashboardOrders from "../components/dashboard/DashboardOrders";
import RestaurantInsights from "../components/dashboard/RestaurantInsights";


const Dashboard = () => {
    const dispatch = useDispatch();
    const userRole = useSelector((state) => state.auth.selectedRole);
    const {
        items: orderData,
        fetchStatus,
        orderSummary,
        fetchOrderSummaryStatus,
        error
    } = useSelector((state) => state.order);

    const { items: conatctUs } = useSelector((state) => state.contact);

    const items = orderData;

    const getCardDataByRole = (userRole, items, orderSummary) => {
        if (
            (userRole?.role === Role.Admin || userRole?.role === Role.Owner) &&
            userRole?.scope === Scope.Branch
        ) {
            return getCardsData(orderSummary);
        }
        if (
            (userRole?.role === Role.Admin || userRole?.role === Role.Owner) &&
            userRole?.scope === Scope.Restaurant
        ) {
            console.log('orderSummary', orderSummary)
            return getRestaurantCardsData(orderSummary, conatctUs.length);

        }
        if (userRole?.role === Role.Employee) {
            return getEmployeeCardsData(items);
        }
        return [];
    };
    useEffect(() => {
        if (userRole) {
            dispatch(fetchOrderSummary(userRole));
            dispatch(fetchOrders(userRole));
        }
        if ((userRole?.scope === Scope.Restaurant &&
            (userRole?.role === Role.Admin || userRole?.role === Role.Owner))) {
            dispatch(fetchAllContact())
        }
    }, [dispatch, userRole]);

    const cardData = getCardDataByRole(userRole, items, orderSummary);
    const recentOrders = items?.slice(0, 5).reverse();

    const employeeChartData =
        userRole?.role === Role.Employee
            ? getEmployeeChartData(items)
            : null;

    return (
        <>
            {/* Branch-level dashboard for Admin/Owner */}
            {(userRole?.scope === Scope.Branch &&
                (userRole?.role === Role.Admin || userRole?.role === Role.Owner)) && (
                    <div className="container p-0 ms-0">
                        {fetchOrderSummaryStatus === "loading" && <p>Loading...</p>}
                        {fetchOrderSummaryStatus === "failed" && (
                            <h6 className="text-danger">{error}</h6>
                        )}
                        {fetchOrderSummaryStatus === "success" && (
                            <>
                                <DashboardCards data={cardData} />
                                <DashboardChat data={orderSummary?.last30Days} isEmployee={false} />
                            </>
                        )}
                    </div>
                )}

            {/* Restaurant-level dashboard for Admin/Owner */}
            {(userRole?.scope === Scope.Restaurant &&
                (userRole?.role === Role.Admin || userRole?.role === Role.Owner)) && (
                    <div className="container p-0 ms-0">
                        {fetchOrderSummaryStatus === "loading" && <p>Loading...</p>}
                        {fetchOrderSummaryStatus === "failed" && (
                            <h6 className="text-danger">{error}</h6>
                        )}
                        {fetchOrderSummaryStatus === "success" && (
                            <>
                                <DashboardCards data={cardData} />
                                <RestaurantInsights data={orderSummary} />
                            </>
                        )}
                    </div>
                )}

            {/* Employee-level dashboard for Employee */}
            {(userRole?.scope === Scope.Branch &&
                (userRole?.role === Role.Employee)) && (
                    <div className="container p-0 ms-0">
                        {fetchStatus === "loading" && <p>Loading...</p>}
                        {fetchStatus === "failed" && (
                            <h6 className="text-danger">{error}</h6>
                        )}
                        {fetchStatus === "success" && (
                            <>
                                <SubHeader title="Orders" />
                                <DashboardCards data={cardData} />
                                <DashboardOrders items={recentOrders} />
                                <div className="mt-7">
                                    <DashboardChat data={employeeChartData} isEmployee={true} />
                                </div>
                            </>
                        )}
                    </div>
                )}
        </>
    );
}
export default Dashboard;
